import React, { useState, useEffect, useContext } from "react";
import SubsidiaryLocationReadOnlyRow from "./SubsidiaryLocationReadOnlyRow";
import SubsidiaryLocationTableRow from "./SubsidiaryLocationTableRow";
import UserContext from "../contexts/UserContext";
import { useTranslation } from 'react-i18next';
import FetchUtil from "../utils/FetchUtil";
import "../css/ListUsers.css";
import { useNavigate } from "react-router-dom";


function SubsidiaryLocationTable({ key, setSubsidiaryLocation, loginId, companyId }) {
	const navigate = useNavigate();
	const { t } = useTranslation();
	const [add, setAdd] = useState(false);
	const [addRowTop, setAddRowTop] = useState(false);
	const [addRowBottom, setAddRowBottom] = useState(false);
	const [error, setError] = useState("");
	const [isUserSubsidiaryLoading, setIsUserSubsidiaryLoading] = useState(false);
	const [userSubsidiaries, setUserSubsidiaries] = useState([]);
	const [isSubsidiaryLocationLoading, setIsSubsidiaryLocationLoading] = useState(false);
	const [subsidiaryLocations, setSubsidiaryLocations] = useState([]);
	const [count, setCount] = useState(0);
	const closeText = t("page.close");
	const userCtx = useContext(UserContext);

	const initialValues = {
		loginId: loginId,
		companyId: companyId,
		locationKey: 0,
		subsidiaryCompanyId: 0,
	};
	const [formValues, setFormValues] = useState(initialValues);

	const resetCounter = () => {
		setCount(prevCount => prevCount + 1);
	};

	let userCompanyId = (userCtx.role !== "SiteAdmin") ? userCtx.userCompanyId : 0;
	useEffect(() => {
		fetchUserSubsidiaries();
		fetchSubsidiaryLocations();
	}, []);

	const handleClose = (event) => {
		setSubsidiaryLocation(false);
	};

	function fetchUserSubsidiaries() {
		if (!initialValues.companyId || initialValues.companyId === 0 || !initialValues.loginId) {
			return;
		}

		setIsUserSubsidiaryLoading(true);
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				source: "web",
				getAll: true,
				companyId: initialValues.companyId,
				loginId: initialValues.loginId
			}),
		};
		try {
			FetchUtil.fetchAPI("GetSubsidiariesForUser", "/Service/UserService/GetSubsidiariesForUser", requestOptions, retrieveUserSubsidiarySuccess, retrieveUserSubsidiaryFail);
		} catch (error) {
			setIsUserSubsidiaryLoading(false);
			throw new Error(error.message);
		}
	}

	function retrieveUserSubsidiaryFail(redirect) {
		setIsUserSubsidiaryLoading(false);
		if (redirect) {
			navigate("/");
		}
		setError(t("error.userGetSubsidiaryFailed"));
	}

	function retrieveUserSubsidiarySuccess(responseData) {
		let getSubsidiariesForUserResponse;
		if (responseData) {
			getSubsidiariesForUserResponse = responseData.getSubsidiariesForUserResponse;
			if (getSubsidiariesForUserResponse && getSubsidiariesForUserResponse.errorCode === "0") {
				setUserSubsidiaries(getSubsidiariesForUserResponse.subsidiaryList.slice())
			} else if (getSubsidiariesForUserResponse && getSubsidiariesForUserResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (getSubsidiariesForUserResponse) {
				setError(t("error.error") + " " + getSubsidiariesForUserResponse.errorMessage);
			} else {
				setError(t("error.system.fetch"));
			}
		}
		setIsUserSubsidiaryLoading(false);
	}

	function fetchSubsidiaryLocations() {
		setError("");
		if (!initialValues.companyId || initialValues.companyId === 0 || !initialValues.loginId) {
			return;
		}
		resetCounter();
		setIsSubsidiaryLocationLoading(true);
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				source: "web", getAll: true, companyId: initialValues.companyId,
				loginId: initialValues.loginId, userCompanyId: userCompanyId
			}),
		};
		try {
			FetchUtil.fetchAPI("GetUserSubsidiaryLocation", "/Service/PartnerSubsService/GetUserSubsidiaryLocation", requestOptions, retrieveSubsidiaryLocationSuccess, retrieveSubsidiaryLocationFail);
		} catch (error) {
			setIsSubsidiaryLocationLoading(false);
			throw new Error(error.message);
		}
	}

	function retrieveSubsidiaryLocationFail(redirect) {
		setIsSubsidiaryLocationLoading(false);
		if (redirect) {
			navigate("/");
		}
		setError(t("error.subsidiaryGetLocFailed"));
	}

	function retrieveSubsidiaryLocationSuccess(responseData) {
		let fetchUserSubsLocationsResponse;
		if (responseData) {
			fetchUserSubsLocationsResponse = responseData.fetchUserSubsLocationsResponse;
			if (fetchUserSubsLocationsResponse && fetchUserSubsLocationsResponse.errorCode === "0") {
				setSubsidiaryLocations(fetchUserSubsLocationsResponse.locations.slice())
			} else if (fetchUserSubsLocationsResponse && fetchUserSubsLocationsResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (fetchUserSubsLocationsResponse) {
				setError(t("error.error") + " " + fetchUserSubsLocationsResponse.errorMessage);
			} else {
				setError(t("error.system.fetch"));
			}
		}
		setIsSubsidiaryLocationLoading(false);
	}

	const handleDeleteClick = (event, subsidiaryLocationItem, completeCallback) => {
		event.preventDefault();
		deleteSubsidiaryLocation(subsidiaryLocationItem, completeCallback);
	};
	const deleteSubsidiaryLocation = (subsidiaryLocationItem, completeCallback) => {
		let action = 3;
		if (subsidiaryLocationItem.statusCode === 1) {
			action = 4;
		}
		let serverParams = {
			loginId: formValues.loginId,
			locationKey: subsidiaryLocationItem.locationKey,
			subsidiaryCompanyId: subsidiaryLocationItem.subsidiaryCompanyId,
			userCompanyId: userCompanyId,
			source: "web",
			action: action
		};
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};

		try {
			FetchUtil.fetchAPI("DeleteUserSubsidiaryLocation", "/Service/PartnerSubsService/DeleteUserSubsidiaryLocation", requestOptions, deleteSubsidiaryLocationSuccess, deleteSubsidiaryLocationFail, completeCallback);
		} catch (error) {
			setError(error.message);
			if (completeCallback) {
				completeCallback();
			}
		}
	};

	function deleteSubsidiaryLocationFail(redirect, completeCallback) {
		setError(t("error.userLocEditFailed"));
		if (completeCallback) {
			completeCallback();
		}
	}
	function deleteSubsidiaryLocationSuccess(responseData, completeCallback) {
		let deleteUserSubsLocationResponse;
		if (responseData) {
			deleteUserSubsLocationResponse = responseData.deleteUserSubsLocationResponse;
			if (deleteUserSubsLocationResponse) {
				if (deleteUserSubsLocationResponse.errorCode === "0") {
					resetRowTable();
					refreshSubsidiaryLocation();
				} else {
					setError(t("error.error") + " " +
						deleteUserSubsLocationResponse.errorMessage
					);
				}
			}
		}
		if (completeCallback) {
			completeCallback();
		}
	}
	const addRowTableTop = () => {
		setAddRowTop(true);
		setAddRowBottom(false);
		addRowTable();
	};

	const addRowTableBottom = () => {
		setAddRowTop(false);
		setAddRowBottom(true);
		addRowTable();
	};

	const addRowTable = () => {
		setError("");
		if (!add) {
			setAdd(true);
		} else {
			setError(t("error.only1RowAllowed"));
		}

	};
	const removeRowTable = () => {
		setError("");
		resetRowTable();
	};
	const resetRowTable = () => {
		setAddRowTop(false);
		setAddRowBottom(false);
		setAdd(false);
	};
	const handleSubmit = (action, setValues, completeCallback) => {
		setError("");
		let found = false;
		if (!formValues.loginId) {
			setError(t("error.userReqd"));
			if (completeCallback) {
				completeCallback();
			}
			return false;
		}
		if (action === 1) {
			if (subsidiaryLocations.length > 0) {
				subsidiaryLocations.map((subsidiaryLocationItem, index) => {
					if (subsidiaryLocationItem.locationKey === setValues.locationKey && subsidiaryLocationItem.subsidiaryCompanyId === setValues.subsidiaryCompanyId) {
						setError(t("error.locDup"));
						found = true;
						if (completeCallback) {
							completeCallback();
						}
						return false;
					}
				})
			}
			if (!found) {
				saveSubsidiaryLocation(action, setValues, completeCallback);
			}
		}
	};
	const saveSubsidiaryLocation = (action, setValues, completeCallback) => {
		let serverParams = {
			loginId: formValues.loginId,
			companyId: formValues.companyId,
			locationKey: setValues.locationKey,
			subsidiaryCompanyId: setValues.subsidiaryCompanyId,
			source: "web",
			action: action
		};
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};

		try {
			FetchUtil.fetchAPI("AddUpdateUserSubsidiaryLocation", "/Service/PartnerSubsService/AddUpdateUserSubsidiaryLocation", requestOptions, saveSubsidiaryLocationSuccess, saveSubsidiaryLocationFail, completeCallback);
		} catch (error) {
			setError(error.message);
			if (completeCallback) {
				completeCallback();
			}
		}
	};

	function saveSubsidiaryLocationFail(redirect, completeCallback) {
		setError(t("error.userLocEditFailed"));
		if (completeCallback) {
			completeCallback();
		}
	}
	function saveSubsidiaryLocationSuccess(responseData, completeCallback) {
		let addUpdateUserSubsLocationResponse;
		if (responseData) {
			addUpdateUserSubsLocationResponse = responseData.addUpdateUserSubsLocationResponse;
			if (addUpdateUserSubsLocationResponse) {
				if (addUpdateUserSubsLocationResponse.errorCode === "0") {
					resetRowTable();
					refreshSubsidiaryLocation();
				} else {
					setError(t("error.error") + " " +
						addUpdateUserSubsLocationResponse.errorMessage
					);
				}
			}
		}
		if (completeCallback) {
			completeCallback();
		}
	}
	function refreshSubsidiaryLocation() {
		fetchSubsidiaryLocations();
	}
	return (
		<>
			{(userCtx.role === "SiteAdmin" || userCtx.role === "ClientAdmin") ?
				<div className="container-fluid container_list viewh-85">
					<div className="row">
						<div className="col mt-3">
							{(error) ? (
								<div id="inerrorMessage" className="errorblock">
									{error}
								</div>
							) : (<></>)}
						</div>
						{(isSubsidiaryLocationLoading || isUserSubsidiaryLoading) && (<div> <span class="spinner-border spinner-border-sm spinner-lg-size"></span> </div>)}
					</div>
					<div className="row" style={{ margin: "0px" }}>
						<div className="col">
							<a class="popup-close" id="boxclose" onClick={(e) => handleClose(e)} ></a>
						</div>
					</div>
					<div className="row">
						<div className="col">
							<div id="placeholder_1" className="placeholder-pg"></div>
						</div>
					</div>
					<div className="row">
						<div className="col">
							<table className="list-table" role="table">
								<thead>
									<tr role="row">
										<th className="list-th">{t("page.subsidiary")}</th>
										<th className="list-th">{t("page.loc.name")}</th>
										<th className="list-th">{t("page.status")}</th>
										<th className="list-th" style={{ maxWidth: "9vw" }}>
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableTop}>
												{t("page.addRow")}
											</button>&nbsp;&nbsp;
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
												{t("page.delRow")}
											</button>
										</th>
									</tr>
								</thead>
								<tbody role="rowgroup">
									{add && addRowTop &&
										<SubsidiaryLocationTableRow
											index={count}
											userSubsidiaries={userSubsidiaries}
											handleSubmit={handleSubmit}
											setError={setError}
											t={t}
											setAdd={setAdd}
											oddIdx={((subsidiaryLocations.length % 2) > 0) ? true : false} />
									}
									{(subsidiaryLocations.length > 0) ? (
										subsidiaryLocations.map((subsidiaryLocationItem, index) => (
											<SubsidiaryLocationReadOnlyRow
												index={count}
												t={t}
												subsidiaryLocationItem={subsidiaryLocationItem}
												handleDeleteClick={handleDeleteClick}
												oddIdx={((index % 2) > 0) ? true : false}
												add={add}
												setError={setError}
											/>
										))
									) : (<></>)}
									{add && addRowBottom &&
										<SubsidiaryLocationTableRow
											index={count}
											userSubsidiaries={userSubsidiaries}
											handleSubmit={handleSubmit}
											setError={setError}
											t={t}
											setAdd={setAdd}
											oddIdx={((subsidiaryLocations.length % 2) > 0) ? true : false} />
									}
								</tbody>
								{(subsidiaryLocations.length > 10) ? (<tfoot>
									<tr role="row">
										<th className="list-th">{t("page.subsidiary")}</th>
										<th className="list-th">{t("page.loc.name")}</th>
										<th className="list-th">{t("page.status")}</th>
										<th className="list-th" style={{ maxWidth: "9vw" }}>
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableBottom}>
												{t("page.addRow")}
											</button>&nbsp;&nbsp;
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
												{t("page.delRow")}
											</button>
										</th>
									</tr>
								</tfoot>
								) : (<></>)}
							</table>
							<div className="row">
								<div className="col mt-3">
									{(error) ? (
										<div id="inerrorMessage1" className="errorblock">
											{error}
										</div>
									) : (<></>)}
								</div>
							</div>
							<div className="footer">
								<input
									type="button"
									name="edit-close"
									id="edit-close"
									className="btn btn-secondary btn-block" data-dismiss="modal"
									onClick={(e) => handleClose(e)}
									style={{ marginTop: "10px", marginBottom: "10px" }}
									value={closeText}
								></input>
							</div>
						</div>
					</div>
				</div>
				: null}
		</>
	);
}
export default SubsidiaryLocationTable;